var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'flex items-center': true,
    'font-sans': true,
    'text-dark-text-200': _setup.bgColorScheme === 'light',
    'text-light-text-200': _setup.bgColorScheme === 'dark',
  }},[(_setup.isBuilderRegistered)?_c('a',{class:{
      'text-body-extra-small': true,
      'text-dark-text-200 hover-hover:hover:text-dark-text-100 hover-hover:focus-visible:text-dark-text-100 focus-ring:light':
        _setup.bgColorScheme === 'light',
      'text-light-text-200 hover-hover:hover:text-light-text-100 hover-hover:focus-visible:text-light-text-100 focus-ring:dark':
        _setup.bgColorScheme === 'dark',
      'hover-hover:hover:underline': true,
      truncate: true,
    },attrs:{"href":_setup.builderProfileUrl,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_setup.builder.name || _setup.builder.username)+"\n  ")]):_c('span',{staticClass:"text-body-extra-small"},[_vm._v(_vm._s(_vm.__('Anonymous')))]),_vm._v(" "),(_setup.contributorCount > 0)?_c(_setup.OzBaseButton,{class:{
      'contributor-list-button': true,
      'bg-transparent p-0 group': true,
      'text-dark-text-200 hover-hover:hover:text-dark-text-100 hover-hover:focus-visible:text-dark-text-100 focus-ring:light':
        _setup.bgColorScheme === 'light',
      'text-light-text-200 hover-hover:hover:text-light-text-100 hover-hover:focus-visible:text-light-text-100 focus-ring:dark':
        _setup.bgColorScheme === 'dark',
      'ms-0.75': true,
      'text-body-extra-small': true,
      'shrink-0': true,
    },attrs:{"title":_setup.contributorText,"aria-label":_vm.__('Show contributors list')},on:{"click":_setup.showContributorsList}},[_vm._v("\n    +\n    "),_c('span',{staticClass:"hover-hover:group-hover:underline"},[_vm._v(_vm._s(_setup.contributorCount))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ms-0.75 text-body-extra-small shrink-0"},[_c('span',{class:{
        'text-dark-text-300': _setup.bgColorScheme === 'light',
        'text-light-text-300': _setup.bgColorScheme === 'dark',
      }},[_vm._v("\n      •\n    ")]),_vm._v(" "),(_setup.surfaceStore.isScreenshotMode)?_c('time',{staticClass:"ms-0.75"},[_vm._v("\n      "+_vm._s(_setup.getPrettyCurrentDate())+"\n    ")]):_c(_setup.OzRelativeTime,{staticClass:"ms-0.75",attrs:{"datetime":_setup.wallUpdatedAt}})],1),_vm._v(" "),(_setup.isFrozen || _setup.isTemplate)?_c('div',{staticClass:"ms-3 flex gap-2.5"},[(_setup.isFrozen)?[(_setup.canIAdminister)?_c(_setup.OzBaseButton,{class:[
          'p-0 rounded relative group',
          {
            'focus-badge-button:light': _setup.bgColorScheme === 'light',
            'focus-badge-button:dark': _setup.bgColorScheme === 'dark',
          },
        ],on:{"click":_setup.showSurfaceFreezePadletPanel}},[_c(_setup.OzBadge,{class:[
            'h-4',

            // Hover
            'hover-hover:group-hover:bg-gradient-to-r',
            {
              'hover-hover:group-hover:from-popover-overlay-light hover-hover:group-hover:to-popover-overlay-light':
                _setup.skinAccentTextColor === 'white',
              'hover-hover:group-hover:from-transparent-button-hover-dark hover-hover:group-hover:to-transparent-button-hover-dark':
                _setup.skinAccentTextColor === 'black',
            },

            // Focus
            'hover-hover:group-focus:bg-gradient-to-r',
            {
              'hover-hover:group-focus:from-popover-overlay-light hover-hover:group-focus:to-popover-overlay-light':
                _setup.skinAccentTextColor === 'white',
              'hover-hover:group-focus:from-transparent-button-hover-dark hover-hover:group-focus:to-transparent-button-hover-dark':
                _setup.skinAccentTextColor === 'black',
            },

            // Active
            {
              'hover-hover:group-active:!bg-grape-500': _setup.bgColorScheme === 'light',
              'hover-hover:group-active:!bg-canary-500': _setup.bgColorScheme === 'dark',
            },
          ],style:(_setup.isSkinColorAvailable ? { backgroundColor: _setup.skinAccentColorAsRGB, color: _setup.skinAccentTextColor } : {}),attrs:{"text":_vm.__('Frozen'),"size-preset":_setup.OzBadgeSizePreset.Tiny,"color-scheme":_setup.OzBadgeColorScheme.Bare},scopedSlots:_vm._u([{key:"startAdornment",fn:function(){return [_c(_setup.OzIcon,{class:[
                'pe-0.5',
                {
                  'text-dark-text-200': _setup.skinAccentTextColor === 'black',
                  'text-light-text-200': _setup.skinAccentTextColor === 'white',
                },
              ],attrs:{"name":"freeze","size":10}})]},proxy:true}],null,false,1731634089)})],1):_c(_setup.OzBadge,{staticClass:"h-4",style:(_setup.isSkinColorAvailable ? { backgroundColor: _setup.skinAccentColorAsRGB, color: _setup.skinAccentTextColor } : {}),attrs:{"text":_vm.__('Frozen'),"size-preset":_setup.OzBadgeSizePreset.Tiny,"color-scheme":_setup.OzBadgeColorScheme.Bare},scopedSlots:_vm._u([{key:"startAdornment",fn:function(){return [_c(_setup.OzIcon,{class:[
              'pe-0.5',
              {
                'text-dark-text-200': _setup.skinAccentTextColor === 'black',
                'text-light-text-200': _setup.skinAccentTextColor === 'white',
              },
            ],attrs:{"name":"freeze","size":10}})]},proxy:true}],null,false,2921973545)})]:_vm._e(),_vm._v(" "),(_setup.isTemplate)?_c(_setup.OzBadge,{staticClass:"h-4",style:(_setup.isSkinColorAvailable ? { backgroundColor: _setup.skinAccentColorAsRGB, color: _setup.skinAccentTextColor } : {}),attrs:{"data-testid":"surfaceTemplateBadge","text":_vm.__('Template'),"size-preset":_setup.OzBadgeSizePreset.Tiny,"color-scheme":_setup.OzBadgeColorScheme.Bare}}):_vm._e()],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }